import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'

const Refundpolicy = () => {
  return (
    <> 
    <Header/>
    <div className=" container my-5 " style={{ borderBottom: '2px solid #DCDCDC', paddingTop:'100px' }}>
        <h1 className="text-center">Refund Policy</h1>
        <p className="text-center mb-5">Last Updated on 24 March 2023</p>
    </div>
    <div className='container'>
        <div className='row'>
            <div className='col-lg-7 col-md-7 col-sm-12 pt-4 pb-5'>

                <h2 className='pb-3'>Effective Date: 24 March 2023</h2>
                <p style={{ color: '#343434' }}>
                    We RNS IT Solutions Private Limited, the provider of Intelli X 360, is committed to providing our users with high-quality services and ensuring their satisfaction with our platform. This Refund Policy outlines our policies and procedures regarding refunds for our SAAS-based platform for educational enterprises.
                </p>

                <h3 className='pt-4 pb-2'>Subscription Plans and Refunds</h3>

                <p className='pt-2'>Intelli X 360 offers subscription plans that are billed on annual basis. Users can choose to cancel their subscription at any time.</p>
                <p>If a user cancels their subscription within the first 14 days of purchase, they may be eligible for a full refund of the subscription fee.</p>
                <p>To request a refund, the user must contact us at help@intellix360.com within 14 days of the initial purchase date.</p>
                <p>After the initial 14-day period, refunds for subscription fees will not be granted. Users may continue to use the platform until the end of their billing cycle and will not be charged for the following billing cycle.</p>

                <h3 className='pt-4 pb-2'>Refunds for Technical Issues</h3>

                <p>If Intelli X 360 experiences technical issues that prevent users from accessing the platform or using its features, users may be eligible for a refund of the subscription fee.</p>
                <p>To be eligible for a refund, the user must contact us at help@intellix360.com and provide evidence of the technical issue.</p>
                <p>We will investigate the issue and determine whether a refund is appropriate. If a refund is granted, it will be prorated based on the number of days the user was unable to access or use the platform.</p>


                <h3 className='pt-2 pb-2'>Refunds for Other Reasons</h3>

                <p className='my-3'>Refunds for reasons other than those listed above, such as dissatisfaction with the platform's features or performance, are not guaranteed. We encourage users to contact us at help@intellix360.com to discuss any issues they are experiencing and to explore potential solutions.</p>

                <h3 className='pt-3 pb-2'>Refund Process</h3>

                <p>To request a refund, users must contact us at help@intellix360.com and provide the following information:</p>
                <ul>
                    <li>Name and email address associated with the Intelli X 360 account</li>
                    <li>Date of purchase</li>
                    <li>Reason for requesting a refund</li>
                </ul>

                <h3 className='pt-2 pb-2'>Contact Us</h3>

                <p >If you have any questions or concerns about this Refund Policy, please contact us at help@intellix360.com or by mail at:<br />
                    Plot No. 197, 101-103, Chanda tower, Main Gandhi Path Road, Jaipur-302021</p>

                <h3 className='pt-3 pb-4'>Changes to this Privacy Policy</h3>
                <p className='pt-2 pb-2'>We may update this Privacy Policy from time to time to reflect changes in our practices or legal obligations. Users will be notified of any material changes and asked to review and accept the new terms before continuing to use Intelli X 360.</p>

                <h3 className='pt-2 pb-2'>Contact Us</h3>
                <p>If you have any questions or concerns about this Privacy Policy, please contact us at help@intellix360.com .</p>
                <p>Plot No. 197, 101-103, Chanda tower, Main Gandhi Path Road, Jaipur-302021</p>

            </div>
        </div>
    </div>

    <section>
     <Footer />
    </section>
</>
  )
}

export default Refundpolicy
